import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    enabled: Boolean,
    delay: { type: Number, default: 0 }
  }

  connect() {
    if (!this.enabledValue) return

    window.setTimeout(() => {
      this.element.click()
    }, this.delayValue)
  }
}
